/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Input, Button, List, Card, message, Modal, Row, Col } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import "./style.scss";
import urls from "../../../api/urls";
import NormalAPI from "../../../api";
import Heading from "../../../components/Heading";
import DropDownComponent from "../CommonComponents/DropDownComponent";
import { getHubList } from "../../../services/api/hub";

const {
    GET_ALL_PINCODE_HUB_WISE_MAPPING,
    DELETE_PINCODE_HUB_WISE_MAPPING,
    ADD_PINCODE_HUB_WISE_MAPPING
} = urls;
const HubToPinCodeMapping = () => {
    const [pincode, setPincode] = useState("");
    const [pincodes, setPincodes] = useState([]);
    const isFetched = useRef(false);
    const [roles, setRoles] = useState();
    const [selectedPremiseId, setSelectedPremiseId] = useState(null);
    const [hubList, setHubList] = useState([]);
    const [hubLoading, setHubLoading] = useState(false);
    const { confirm } = Modal;

    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem("userinfo"));
        setRoles(userInfo);

        // Fetch hub list
        fetchHubList();
    }, []);

    useEffect(() => {
        // Fetch pincodes when premise is selected
        if (selectedPremiseId && isFetched.current) {
            getALL_PINCODE_MAPPED_WITH_HUB();
        }
    }, [selectedPremiseId]);

    const fetchHubList = async () => {
        try {
            setHubLoading(true);
            const hubs = await getHubList();
            setHubList(hubs);
            // Auto-select first hub if available
            if (hubs.length > 0 && !selectedPremiseId) {
                setSelectedPremiseId(hubs[0].value);
                if (!isFetched.current) {
                    isFetched.current = true;
                }
            }
        } catch (error) {
            message.error("Failed to fetch hub list");
            setHubLoading(false);
        } finally {
            setHubLoading(false);
        }
    };
    const handleSave = () => {
        if (!pincode.trim()) return;
        const formattedPincode = pincode.trim();
        const formattedPincodes = pincodes.map(String);
        if (!formattedPincodes.includes(formattedPincode)) {
            addPincodeToHub();
        } else {
            message.error("Pincode already exists.");
        }
    };
    const showDeleteConfirm = (pin) => {
        let timer = 5; // 5 seconds
        let interval;
    
        const modal = confirm({
            title: "Are you sure you want to delete this pincode?",
            icon: <ExclamationCircleOutlined />,
            content: `Pincode: ${pin}`,
            okText: `Yes, Delete (${timer}s)`, // Initial text with countdown
            okType: "danger",
            cancelText: "Cancel",
            okButtonProps: { disabled: true }, // Disable initially
            onOk() {
                handleDelete(pin);
            },
            onCancel() {
                clearInterval(interval); // Clear timer if canceled
            },
        });
    
        // Start countdown
        interval = setInterval(() => {
            timer -= 1;
            modal.update({
                okText: `Yes, Delete (${timer}s)`,
            });
    
            if (timer <= 0) {
                clearInterval(interval);
                modal.update({
                    okText: "Yes, Delete",
                    okButtonProps: { disabled: false }, // Enable button after 100 sec
                });
            }
        }, 1000);
    };
    
    const handleDelete = (pin) => {
        deletePincodeHubWise(pin);
    };

    const getALL_PINCODE_MAPPED_WITH_HUB = async (params) => {
        if (!selectedPremiseId) {
            return;
        }
        try {
            const response = await NormalAPI.Api(GET_ALL_PINCODE_HUB_WISE_MAPPING).NodeGetWithCustomHeader({
                "SMCS-PREMISE-ID": selectedPremiseId.toString()
            });
            if (response?.status) {
                const pincodeData = response?.response?.data?.pincodes || [];
                setPincodes(pincodeData);
            } else {
                message.error(response?.response?.data?.message);
            }
        } catch (error) {
            message.error(error?.message);
        }
    };
    const addPincodeToHub = async () => {
        if (!selectedPremiseId) {
            message.error("Please select a hub first");
            return;
        }
        try {
            let payload = {
                premiseId: selectedPremiseId,
                pincodes: [pincode],
            };
    
            const response = await NormalAPI.Api(ADD_PINCODE_HUB_WISE_MAPPING).postCustomHeader(payload, {
                "SMCS-PREMISE-ID": selectedPremiseId.toString(),
                "USER-ID": JSON.parse(localStorage.getItem("userId"))?.userInfo?.userId || ""
            });
    
            if (response?.status) {
                setPincode(""); // Clear input
                message.success(response?.response?.data?.message);
                getALL_PINCODE_MAPPED_WITH_HUB(); // Refresh list
            } else {
                message.error(response?.response?.data?.message);
            }
        } catch (error) {
            message.error(error?.response?.data?.message);
        }
    };
    
    const deletePincodeHubWise = async (data) => {
        if (!selectedPremiseId) {
            message.error("Please select a hub first");
            return;
        }
        try {
            let request = {
                premiseId: selectedPremiseId,
                pincodes: [data],
            };
    
            // Use axios directly for DELETE with custom headers
            const userData = JSON.parse(localStorage.getItem("userinfo"));
            const userId = JSON.parse(localStorage.getItem("userId"))?.userInfo?.userId || "";
            
            const response = await axios.delete(DELETE_PINCODE_HUB_WISE_MAPPING, {
                headers: {
                    Authorization: "Bearer " + userData?.accessToken,
                    "SMCS-PREMISE-ID": selectedPremiseId.toString(),
                    "USER-ID": userId,
                    "X-Request-ID": uuidv4(),
                },
                data: request,
            });
    
            if (response?.status === 200 || response?.status === 204) {
                message.success(response?.data?.message || "Pincode deleted successfully");
                getALL_PINCODE_MAPPED_WITH_HUB(); // Refresh list
            } else {
                message.error(response?.data?.message || "Failed to delete pincode");
            }
        } catch (error) {
            message.error(error?.response?.data?.message || error?.message || "Failed to delete pincode");
        }
    };

    return (
        <Card className="hub-pincode-container">
            <Heading
                title="Hub to Pincode Mapping"
            />
            <div className="hub-pincode-wrapper">
                {/* Add Pincode Card */}
                <Card title="Add Pincode" className="hub-pincode-card">
                    <div className="hub-dropdown-section">
                        <div className="filter-label">Hub</div>
                        <DropDownComponent
                            placeholder="Select Hub"
                            options={hubList}
                            onChange={(value) => {
                                setSelectedPremiseId(value);
                                setPincodes([]); // Clear pincodes when hub changes
                            }}
                            value={selectedPremiseId}
                            allowClear={false}
                            loading={hubLoading}
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </div>
                    <div className="pincode-input-container">
                        <Input
                            type="number"
                            placeholder="Enter 6-digit Pincode"
                            value={pincode}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,6}$/.test(value)) {
                                    setPincode(value);
                                }
                            }}
                            maxLength={6} // Prevents input beyond 6 digits
                            minLength={6}
                            onPressEnter={handleSave}
                            className="pincode-input"
                            disabled={!selectedPremiseId}
                        />
                        <Button type="primary" onClick={handleSave} disabled={pincode.trim().length !== 6 || !selectedPremiseId}>
                            Save
                        </Button>
                    </div>
                </Card>

                {/* Mapped Pincodes Card */}
                <Card title="Mapped Pincodes" className="hub-pincode-card">
                    <div className="pincode-list">
                        {pincodes.length > 0 ? (
                            pincodes.map((pin) => (
                                <div key={pin} className="pincode-item">
                                    {pin}
                                    <DeleteOutlined onClick={() => showDeleteConfirm(pin)} className="delete-icon" />
                                </div>
                            ))
                        ) : (
                            <p className="empty-text">No Pincodes Added</p>
                        )}
                    </div>
                </Card>
            </div>
        </Card>
    );
};

export default HubToPinCodeMapping;
